import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '+500',
    label: 'docentes confían'
  }, {
    value: '6',
    label: 'Tomos listos'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: '⭐⭐⭐⭐⭐'
  }];
  return <section className="px-6 py-8" data-id="element-230">
      <div className="max-w-6xl mx-auto" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-232">
          {stats.map((stat, idx) => <div key={idx} className="bg-petroleo rounded-2xl p-6 text-center border border-tealBrand/20" data-id="element-233">
              <div className="text-3xl font-bold text-white mb-1" data-id="element-234">
                {stat.value}
              </div>
              <div className="text-sm text-gray-300 font-medium" data-id="element-235">
                {stat.label}
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}